import { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import usePermissionsHook from '../../components/ElementWithPermissions/usePermissionsHook';

const useRows = ({
  handleOpenModal,
  handleOpenConfirmModal,
  housingAssistanceVouchers,
  stage,
}) => {
  const { housingVoucherCoverRentSwitch } = useFlags();
  const hasEditPermission = usePermissionsHook({
    scope: ['housing-assistance-edit'],
  });

  return useMemo(() => {
    return housingAssistanceVouchers.map((row) => {
      const voucherSource = row.voucherSource;
      const voucherAmount = row.voucherAmount;
      const residentRent = row.residentRent;
      const coversRentChanges = row.coversRentChanges;
      const voucherStartDate = row.voucherStartDate;
      const voucherEndDate = row.voucherEndDate;

      // deletion allowance
      const isStartDateInTheFuture =
        voucherStartDate && new Date(voucherStartDate) > new Date();

      const showDelete = isStartDateInTheFuture || stage === 'applicant';
      return {
        voucherSource: {
          variant: 'description',
          value: voucherSource,
        },
        voucherAmount: {
          variant: 'currency',
          value: voucherAmount,
        },
        residentRent: {
          variant: 'currency',
          value: residentRent,
        },
        ...(housingVoucherCoverRentSwitch
          ? {
              coversRentChanges: {
                variant: 'boolean',
                value: coversRentChanges || false,
                iconName: 'AlertInfoIcon',
                color: 'success',
              },
            }
          : {}),
        voucherStartDate: {
          variant: 'date',
          value: voucherStartDate,
        },
        voucherEndDate: {
          variant: 'date',
          value: voucherEndDate || null,
        },
        actions: {
          variant: 'iconButtons',
          array: [
            {
              name: 'edit',
              iconName: 'PencilIcon',
              color: 'primary',
              disabled: !hasEditPermission,
              onClick: () => {
                handleOpenModal({
                  modalType: 'editVoucher',
                  voucher: {
                    id: row.id,
                    voucherSource,
                    voucherAmount,
                    voucherStartDate,
                    voucherEndDate,
                    coversRentChanges,
                  },
                });
              },
            },
            ...(showDelete
              ? [
                  {
                    name: 'delete',
                    iconName: 'TrashIcon',
                    color: 'error',
                    disabled: false,
                    onClick: () => {
                      handleOpenConfirmModal({
                        modalType: 'deleteVoucher',
                        voucher: {
                          id: row.id,
                        },
                      });
                    },
                  },
                ]
              : []),
          ],
        },
      };
    });
  }, [
    housingAssistanceVouchers,
    stage,
    handleOpenModal,
    handleOpenConfirmModal,
    hasEditPermission,
    housingVoucherCoverRentSwitch,
  ]);
};

export default useRows;
